"use strict";

angular.module('app.sessionTimeout', [

])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.sessionTimeout', {
                templateUrl: 'components/sessionTimeout/sessionTimeoutView.html',
                controller: [ '$stateParams', '$scope', '$location',
                    function($stateParams, $scope, $location) {
                        $scope.stateParams = $stateParams;
                        $scope.openUrl = function(url) {$location.url(url);}
                    },
                ],

                title: 'Session Timeout',
                noSidebar: true,
                noTopControls: true,
            });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/sessionTimeout/sessionTimeout.js